import { BrowserModule }           from '@angular/platform-browser';
import { NgModule }                from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppRoutingModule }        from './app-routing.module';
import { AppComponent }            from './app.component';
import { ComponentsModule }        from './components/components.module';
import { DirectivesModule }        from './directives/directives.module';
import { PipesModule }             from './pipes/pipes.module';
import { PagesModule }             from './pages/pages.module';
import { FormsModule }             from '@angular/forms';
import { HttpClientModule }        from '@angular/common/http';
import { ProductDetailComponent }  from './modals/product-detail/product-detail.component';
import { MatDialogModule }         from '@angular/material/dialog';
import { DialogComponent }         from './components/dialog/dialog.component';
import { registerLocales } from "../shared/pipes/currency.pipe";

registerLocales();

const DIALOGS = [
	ProductDetailComponent,
	DialogComponent
];

@NgModule({
	declarations: [
		AppComponent,
		ProductDetailComponent
	],
	imports: [
		BrowserModule,
		AppRoutingModule,
		ComponentsModule,
		DirectivesModule,
		PipesModule,
		PagesModule,
		FormsModule,
		HttpClientModule,
		BrowserAnimationsModule,
		MatDialogModule
	],
	providers: [],
	bootstrap: [AppComponent],
	entryComponents: [
		...DIALOGS
	]
})
export class AppModule {
}
